export default __webpack_public_path__ + "static/media/introduction.79f83ebd.svg";